import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ButtonModule } from 'primeng/button';
import { Toast } from 'primeng/toast';

import { NgIcon } from '@ng-icons/core';

@Component({
  selector: 'custom-toast',
  standalone: true,
  imports: [Toast, ButtonModule, NgIcon, RouterModule],
  template: `
    <p-toast position="top-center" key="confirm">
      <ng-template let-message #headless>
        @let icon =
          message.severity === 'error' ? 'phosphorXCircle' : 'phosphorCheck';
        <div class="mx-3 my-2 flex items-center gap-3">
          <ng-icon [name]="icon" size="24px" />
          <div class="w-11/12 text-sm font-normal">
            {{ message.summary }}
            @if (message.data?.link) {
              <a
                [routerLink]="message.data.link"
                [queryParams]="message.data.queryParams"
                class="cursor-pointer font-medium underline"
                [style.color]="getLinkColor(message.severity)"
                >{{ message.data.linkText || 'Click here' }}</a
              >
            }
          </div>
        </div>
      </ng-template>
    </p-toast>
  `,
  styles: `
    :host ::ng-deep .p-toast-message {
      display: inline-flex !important;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomToast {
  getLinkColor(severity: string): string {
    const map: Record<string, string> = {
      success: '#15803d', // green-700
      info: '#1d4ed8', // blue-700
      warn: '#b45309', // amber-700
      error: '#b91c1c', // red-700
      help: '#7e22ce', // purple-700
      primary: '#1d4ed8', // blue-700
      secondary: '#374151', // gray-700
      contrast: '#111827', // gray-900
    };
    return map[severity] ?? '#374151';
  }
}
